import { Observable, take } from "rxjs";

/**
 * Provides RXJS helper functions
 */
export class RxjsHelper {
  /**
   * Creates a Promise from an Observable
   * @param obs The Observable
   * @returns The Promise
   */
  public static toPromise<T>(obs: Observable<T>): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      obs.pipe(take(1)).subscribe({
        next: (data: T) => { resolve(data); },
        error: (error: any) => { reject(error); }
      });
    });
  }
}
